import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { setCoachingfeedBacks } from "../../../../reducer/mediumSlice";
import { setLoading } from "../../../../reducer/auth/auth";
import { getPracticeFeedbacks, publishFeedback } from "../../../../services/medium";
import InfoPopup from "../../../../components/infopopup";
import FeedBackTimeBox from "../subcomponents/feedbacktimebox";
import Button from "../../../../components/button";
import "../index.css";
// import "./feedback.css";
import { toast } from "react-toastify";

export default function DemonstrationFeedback() { 
  const { coachingfeedBacks } = useSelector((state) => state.medium);
  const dispatch = useDispatch();
  // const [activeTab, setActiveTab] = useState(0);
  const [localFeedBacks, setLocalFeedBacks] = useState([]);
  const [active, setActive] = useState({});
  const [publishActiveItem, setPublishActiveItem] = useState()
  const [sessionType, setSessionType] = useState([])
  const [localFeedBacksstatus, setLocalFeedBacksstatus] = useState([]);


  useEffect(() => {
    callBack();
    if (!coachingfeedBacks.length) callBack();
  }, []);
  useEffect(() => {
    let info = coachingfeedBacks.map((data) => {
      return false;

    })
    setLocalFeedBacksstatus(info);
    setLocalFeedBacks(coachingfeedBacks);
  }, [coachingfeedBacks]);

  function groupBy(objectArray, property) {
    const grouped = new Map();
    
    objectArray.forEach((item) => {
        const key = item[property];
        if (!grouped.has(key)) {
            grouped.set(key, []);
        }
        grouped.get(key).push(item);
    });
    
    // Convert Map to array of arrays, maintaining order
    return Array.from(grouped.values());
  }

  const callBack = () => {
    const subsession_table = [
  99,
  101
];
  const session_table = [
  33,
  35
];
    getPracticeFeedbacks(session_table.join(","),subsession_table.join(","))
      .then((data) => {
        if (data.data.status) {

          let info = []

          if (typeof (info) === 'object') {
            const propertyValues = Object.values(data.data.data);
            info = propertyValues.map((feed) => {
              delete feed.feedback['about_verysoul'];
              delete feed.feedback['anything_else'];
              return feed;
            })
          }
          else {
            info = data.data.data.map((feed) => {
              delete feed.feedback['about_verysoul'];
              delete feed.feedback['anything_else'];
              return feed;
            })
          }
          let grouped = groupBy(info, "appointment");

        // grouped is already: [ [obj, obj], [obj] ]
        dispatch(
          setCoachingfeedBacks(
            info.map(item => [item]) // 👈 wrap only
          )
        );
        }
      })
      .catch(() => { });
  };

  const openMoreInfo = (info) => {
    let array = []; 
    var feedback = info && info[0].feedback? info[0].feedback : "";
    var dataSession =  info;
    setSessionType(dataSession);
    if(feedback){
      const arrayData = Object.keys(dataSession).map(key => dataSession[key]);
      setSessionType(arrayData);
      Object.values(info).map((item) => {
        // "This experience was helpful to me overall" leads, the client's overall comment ends the popup.
        array.push({
          "This experience was helpful to me overall": item.helpful_score ? item.helpful_score : "",
          ...item.feedback,
          ...(item.overall_comment ? { "Overall Comment": item.overall_comment } : {}),
        });
      });
      setActive(array);
      window.loadModal2("#infopopup", "show");
    }
  };
  const updatePublishStatus = (id, status, duration = "") => {
    dispatch(setLoading(true));
    let body = {
      feedback_id: id,
      status: status,
      // duration: duration,
    };
    publishFeedback(body)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status && status === 0) {

          toast.success("Feedback Consider Succesfully", {
            position: "top-center",
          });

        }
        if (data.data.status && status === 1) {
          window.loadModal2("#feedbacktimebox", "hide");
          toast.success("Publish Requested Succesfully", {
            position: "top-center",
          });

        }
        callBack()
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
  const openApproveContainer = (item) => {
    setPublishActiveItem(item);
    window.loadModal2("#feedbacktimebox", "show");
  };
  const onClickHandler = (e, index) => {
    let info = localFeedBacksstatus.map((data, i) => {
      if (i === index) {
        return !data;
      }
      else {
        return false;
      }
    })

    setLocalFeedBacksstatus(info);
  }
  return (
    <>
      <div className="dashboard">
        <div className="row">
          <div className="col-md-12">
            <div className="my-ppointments-box appoint-das">
              <div className="table-box-medium admin-feed-page">
                <table className="caseTable">
                  <tbody>
                    <tr className="dark">
                      <th>Session #</th>
                      <th>Helpful Rating</th>
                      <th>Overall Comment</th>
                      <th>Client Name</th>
                      <th>Feedback</th>
                     
                      <th>Session Date</th>
                      <th>Session Time</th>
                      <th>Survey Date</th>
                     
                    </tr>
                    {localFeedBacks.length > 0 ? (
                      localFeedBacks.map((item, index) => (
                        <tr className="innr">
                          <td>{item[0].front_appointment_id}</td>
                          <td>{item[0].helpful_score ? item[0].helpful_score  : ""}</td>
                          <td>{item[0].overall_comment ? item[0].overall_comment : ""}</td>
                          <td className="">{item[0].client_name}{" "}{" "}{item[0].is_client == 1 ? "(client)" : ""}</td>
                          <td className=""><button 
                            className="font-size-14 mr-3 pointer learn-more-btn btnView"
                            onClick={() => openMoreInfo(item)}
                          >
                            View
                          </button></td>
                         
                          <td className="">
                            {moment(item[0].session_date).format("LL")}
                          </td>
                          <td className="">
                            {/* {item[0].session_time} */}
                            {moment(item[0].session_time, ["h:mm A"]).format(
                              "hh:mm a"
                            )}
                          </td>
                          {/* <td className="">{item[0].session_type}</td> */}
                          
                          <td>
                            {moment(item[0].date).format("LL")}
                          </td>
                         

                          {/********** */}
                          {/* <td className="feedBack-action-box-medium">
                            <Button
                              className={`resend-btn w-unset height-35 min-width-130px`}
                              title="Approve"
                              status={0}
                              onClick={() => updatePublishStatus(item[0].feedback_id, 1, "")}
                            />
                            <Button
                              className={`resend-btn w-unset height-35 min-width-130px`}
                              title="Consider"
                              status={0}
                              onClick={() =>
                                updatePublishStatus(item[0].feedback_id, 0, "")
                              }
                            />
                            <img
                              title="More"
                              onClick={() => openMoreInfo(item)}
                              className="pointer"
                              src="/localImages/openeye.svg"
                              alt="eye"
                            />
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={12} className="text-center">
                          No Feedbacks Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <InfoPopup feedBackinfo={active} sessionType={sessionType}/>
        <FeedBackTimeBox publishMediumFeedback={updatePublishStatus} info={publishActiveItem} />
      </div>
    </>
    // <div className="all-medium-page">
    //   <Tabs list={list} setActiveTab={setActiveTab} />
    //   <ul className="tabs-content">
    //     <TabPanel id={0} activeTab={activeTab}>
    //       <IntermediateFeedback />
    //     </TabPanel>
    //     <TabPanel id={1} activeTab={activeTab}>
    //       <PartnerFeedback />
    //     </TabPanel>
    //     <TabPanel id={2} activeTab={activeTab}>
    //       <ProfessionalFeedback />
    //     </TabPanel>
    //   </ul>
    // </div>
  );
}
